export default {
    login: 'ログイン',
    logout: 'ログアウト',
    register: '新規登録',
    upload: 'アップロード',
    name: '名前',
    email: 'メールアドレス',
    password: 'パスワード',
    passwordConfirmation: 'パスワード（確認用）',
    isCommunityManager: 'コミュニティマネージャー',
    dashboard: 'ダッシュボード',
    offerLists: 'オファーリスト',
    schedule: 'スケジュール',
    accountEdit: 'アカウント情報を編集',
    edit: '編集',
    detail: '詳細',
    fullname: '{{lastname}} {{firstname}}',
    quantity: '個数',
    quantityWithWeight: '個数 (重量)',
    confirmTitle: '確認',
    orderInformation: '予約情報',
    orderPrices: '価格変更履歴',
    invoices: '請求書',
    contact: '問い合わせ',
    when: '日時',
    add_to_google_calendar: 'Google カレンダーに追加',
    pages: {
        dashboard: {
            unpaidInvoices: {
                title: '未入金請求書リスト(未入金請求書は期限が古い順で最大１０件分表示）',
                totalUnpaidAmountAll: '未入金合計金額（総計）',
                totalUnpaidAmountExpired: '未入金合計金額（期限超え分）',
                more: 'すべて見る',
            },
            typicaStockItemDelaySummaryPanel: {
                title: 'TYPICA selection滞留状況',
                chartTitleFromImported: '入庫〜購入',
                chartTitleFromPurchased: '購入〜配送',
                within1month: '1ヶ月以内',
                within2month: '2ヶ月以内',
                within3month: '3ヶ月以内',
                within4month: '4ヶ月以内',
                within5month: '5ヶ月以内',
                over5month: '5ヶ月以上',
                unitLabel: '重量(Kg)',
            },
            remainingWarehouseItems: {
                title: 'プレオーダー(納品後一括払い、または都度払い)の滞留状態',
                subTitles: {
                    byPeriod: '期間別',
                    byCommunityManager: '担当者(コミュニティマネージャ)別',
                    byOffice: '拠点別',
                },
                more: 'すべて見る',
                unitLabel: '重量(Kg)',
            },
        },
        offerUpload: {
            title: 'アップロード CSV',
            producer: 'プロデューサー',
            download: 'CSVテンプレートがあります',
            sampleDeliveryDateMemo: 'オファー開始希望日の14日以前である必要があります',
            uploadMemo: 'アップロード完了後、担当者より後日ご連絡いたします',
            suggestToCreateBankAccountText: "\u58F2\u4E0A\u91D1\u306E\u53D7\u3051\u53D6\u308A\u306B\u5FC5\u305A\u9280\u884C\u53E3\u5EA7\u306E\u6307\u5B9A\u304C\u5FC5\u8981\u3067\u3059\u3002\nSales Contract\u767A\u884C\u6642\u306B\u306F\u5FC5\u9808\u3068\u306A\u308B\u306E\u3067\u3001\u30AA\u30D5\u30A1\u30FC\u30EA\u30B9\u30C8\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u306E\u6642\u70B9\u3067\u767B\u9332\u3057\u3066\u304A\u304F\u3053\u3068\u3092\u304A\u3059\u3059\u3081\u3057\u307E\u3059\u3002",
        },
        offerList: {
            title: '{{country}} / {{ name }} のオファーリスト',
            createInvoices: '請求書を発行する',
            createInvoicesExplanation: "\u767B\u9332\u3055\u308C\u305F\u4E88\u7D04\u60C5\u5831\u5185\u3067\u652F\u6255\u3044\u30BF\u30A4\u30DF\u30F3\u30B0\u304C\u300C1. \u751F\u7523\u8005\u306E\u5E0C\u671B\u901A\u308A\u306B\u4E00\u62EC\u652F\u6255\u3044\u300D\u306E\u3082\u306E\u306B\u305F\u3044\u3057\u3066\u3001\u4E00\u62EC\u3067\u8ACB\u6C42\u66F8\u3092\u767A\u884C\u3057\u307E\u3059\u3002\n\u305F\u3060\u3057\u3001\u3059\u3067\u306B\u8ACB\u6C42\u66F8\u306E\u767A\u884C\u3055\u308C\u305F\u4E88\u7D04\u306B\u5BFE\u3057\u3066\u306F\u3001\u65B0\u898F\u306B\u8ACB\u6C42\u66F8\u306F\u4F5C\u6210\u3057\u307E\u305B\u3093\u3002\n\u4F5C\u6210\u3055\u308C\u305F\u8ACB\u6C42\u66F8\u306EURL\u306F\u5404\u30ED\u30FC\u30B9\u30BF\u30FC\u3078\u30E1\u30FC\u30EB\u3067\u901A\u77E5\u3055\u308C\u307E\u3059\u3002",
            sampleOrderStock: {
                quantity: 'サンプル在庫の振り分け',
                lotVisibleLabel: 'Lotの表示・非表示',
                show: '表示',
                hide: '非表示',
            },
            publishedCountriesTableTitle: '販売国',
            basicInformations: '基本情報',
            publishedCountriesTable: '販売国',
            transportToWarehouseTable: '倉庫単位輸送情報',
            officeDetailTable: '拠点情報',
            offersTable: 'Offers',
            contracts: '契約関連',
            sampleOrderPeriod: 'サンプル受付',
            orderPeriod: '予約受付',
            paymentPeriod: '支払時期',
            estimatedDeliveryPeriod: 'お届け目安',
            paymentAfterDelivery: '納品後かけ払い',
            paymentPeriods: {
                reserved: '予約時前払い',
                exported: '輸出時支払い',
                imported: '入港時支払い',
                delivered: 'ロースターへの納品時',
            },
            installmentPaymentAfterImport: '入庫後に分割払い',
            installmentPayment: '分割払い',
            estimatedPaymentDateFormat: '{{year}} {{month}} {{date}}',
            installmentPaymentsHelp: {
                title: 'かけ払いについて',
                body: "\u3054\u4E88\u7D04\u306E\u969B\u306B\u300C\u304B\u3051\u6255\u3044\u300D\u3092\u9078\u629E\u3059\u308B\u3068\u3001\u7D0D\u54C1\u5F8C\u306E\u304A\u652F\u6255\u3044\u304C\u53EF\u80FD\u3068\u306A\u308A\u307E\u3059\u3002\n\u521D\u56DE\u7D0D\u54C1\u5F8C\u306B\u300C\u5168\u984D\u304B\u3051\u6255\u3044\u300D\u304B\u3001\u5009\u5EAB\u4FDD\u7BA1\u5206\u3092\u7D0D\u54C1\u6BCE\u306B\u300C\u90FD\u5EA6\u304B\u3051\u6255\u3044\u300D\u304B\u306E\u3044\u305A\u308C\u304B\u3092\u9078\u629E\u3044\u305F\u3060\u3051\u307E\u3059\u3002",
            },
            FreeOnBoardHelp: {
                title: 'FOBとは',
                body: "\u751F\u7523\u56FD\u306E\u6E2F\u306B\u5230\u7740\u3057\u305F\u6642\u70B9\u306E\u30B3\u30FC\u30D2\u30FC\u751F\u8C46\u306E\u4FA1\u683C\u3067\u3059\u3002\n\u6D77\u4E0A\u904B\u8CC3\u3084\u8F38\u5165\u624B\u6570\u6599\u306F\u542B\u307E\u308C\u307E\u305B\u3093\u3002",
            },
            warehouseItemHelp: {
                title: '配送依頼について',
                body: '初回のお支払完了後に商品配送可能となります。',
            },
            estimatedDeliveryPeriodFormat: '{{year}} {{month}} {{monthPart}}',
            okagesamaNoMori: 'OKAGESAMA',
            okagesamaNoMoriContributors: '参画したロースター一覧',
            okagesamaNoMoriTotalPrices: '合計金額',
            okagesamaNoMoriStatuses: {
                title: 'OKAGESAMA参画状態',
                joined: '参画中',
                paid: '参画中(支払い済み)',
            },
        },
        editProfile: {
            title: 'プロフィール編集',
            subTitle: 'お客様情報',
            questionnairesForRoaster: 'ロースターとしてのアンケート',
            questionnairesForRoasterMemo: '※ 下記内容は後から変更も可能です',
            cannotChangeCountry: '※ 所属国は一度登録すると、変更ができないのでご注意ください',
        },
        editAccount: {
            title: 'アカウント情報を編集',
            currentEmail: '現在のメールアドレス',
            warning: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u5909\u66F4\u5F8C\u3001\u4E00\u5EA6\u30ED\u30B0\u30A2\u30A6\u30C8\u3055\u308C\u307E\u3059\u3002\n\u65B0\u3057\u3044\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u5B9B\u306B\u78BA\u8A8D\u7528\u306E\u30E1\u30FC\u30EB\u304C\u9001\u4FE1\u3055\u308C\u307E\u3059\u306E\u3067\u3001\n\u8A18\u8F09\u3055\u308C\u305F\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u53CD\u6620\u304C\u5B8C\u4E86\u3057\u307E\u3059\u3002\n\u305D\u306E\u5F8C\u3001\u65B0\u3057\u3044\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3067\u30ED\u30B0\u30A4\u30F3\u3044\u305F\u3060\u3051\u307E\u3059\u3002",
        },
        exchangeRates: {
            title: '為替レート設定',
            exchangeRateColumnTitle: 'USD/{{ currency }}換算',
        },
        roasterOfferLists: {
            sampleRequest: 'サンプルリクエスト',
            order: '予約',
            inactive: '公開終了',
        },
        roasterOrder: {
            title: '{{ listName }}の予約',
            explanationSelectOffers: '・下記リストにて在庫数をご確認の上、予約数量を選択して下さい。',
            explanationAuctionWithFobPriceUsdPerLb: '※ オークション結果はUSD/Kgによる結果になります。（1kg=2.20462lb）',
            explanationStockMightChange: '※ 画面を開いている間に在庫が無くなる場合があります。ご了承ください。',
            order: '予約',
            orderAmount: '予約',
            totalFee: '合計金額: {{ fee }} (税込)',
            totalBags: '合計袋数：{{ amount }}袋',
            totalOrderedBags: '注文済み袋数：{{ amount }}袋',
            totalWeight: '合計重量：{{ weight }}Kg',
            totalOrderedWeight: '注文済み重量：{{ weight }}Kg',
            totalOneTimeUpfrontOrderedBags: '前払い袋数：{{ amount }}袋',
            typicaHandlingFee: 'TYPICA手数料：{{ percentage }}%',
            typicaHandlingFeeExplanationByBagCount: '5袋未満 {{ lessThan5Bags }} / 5袋以上 {{ moreThan5Bags }} / 10袋以上 {{ moreThan10Bags }} / 50袋以上 {{ moreThan50Bags }}',
            typicaHandlingFeeExplanationByWeight: '300Kg未満 {{ lessThan300Kg }} / 300Kg以上 {{ moreThan300Kg }} / 600Kg以上 {{ moreThan600Kg }} / 3,000Kg以上 {{ moreThan3000Kg }}',
            details: '内訳',
            paymentAndDelivery: '支払い方法・配送先住所',
            paymentMethodExplanation: "\u203B \u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u306E\u5229\u7528\u9650\u5EA6\u984D\u3084\u5206\u5272\u652F\u6255\u3044\u306E\u6761\u4EF6\u306F\u3001\u3054\u5229\u7528\u8005\u69D8\u306B\u3088\u3063\u3066\u7570\u306A\u308A\u307E\u3059\u3002\u8A73\u3057\u304F\u306F\u30AB\u30FC\u30C9\u4F1A\u793E\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u4E0B\u3055\u3044\u3002\n      \u203B \u4E00\u5EA6\u306E\u8ACB\u6C42\u91D1\u984D\u304C\u6574\u6570\u68418\u6841\u3092\u8D85\u3048\u308B\u5834\u5408\u3001\u9280\u884C\u632F\u8FBC\u306B\u306A\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002",
            endOfMonth: '末迄',
            oneTimeUpfrontExplanations: '- お支払期日は{{ paymentDate }}となります。詳細は、オファー終了後に発行される請求書をご確認ください。',
            afterImportPaymentExplanations: "- \u30B3\u30FC\u30D2\u30FC\u751F\u8C46\u304C\u5009\u5EAB\u5165\u5EAB\u65E5\uFF08\u76EE\u5B89: {{ deliveryPeriod }}\uFF09\u304B\u308914\u65E5\u4EE5\u5185\u306E\u304A\u652F\u6255\u3068\u306A\u308A\u307E\u3059\u3002\n      - \u304A\u652F\u6255\u5B8C\u4E86\u5F8C\u306B\u5546\u54C1\u914D\u9001\u53EF\u80FD\u3068\u306A\u308A\u307E\u3059\u3002",
            fewTimesPaymentAfterImportExplanations: "- \u521D\u56DE\u306E\u304A\u652F\u6255\u306F\u30B3\u30FC\u30D2\u30FC\u751F\u8C46\u304C\u5009\u5EAB\u5165\u5EAB\u65E5\uFF08\u76EE\u5B89: {{ deliveryPeriod }}\uFF09\u304B\u308914\u65E5\u4EE5\u5185\u3068\u306A\u308A\u307E\u3059\u3002\n      - \u521D\u56DE\u306E\u304A\u652F\u6255\u5B8C\u4E86\u5F8C\u306B\u5546\u54C1\u914D\u9001\u53EF\u80FD\u3068\u306A\u308A\u307E\u3059\u3002\n      - 2\u56DE\u76EE\u4EE5\u964D\u306E\u304A\u652F\u6255\u306F\u3001\u5009\u5EAB\u5165\u5EAB\u7FCC\u6708\u306E\u6BCE\u6708\u672B\u3068\u306A\u308A\u307E\u3059\u3002\u8A73\u7D30\u306F\u6708\u521D\u306B\u767A\u884C\u3055\u308C\u308B\u8ACB\u6C42\u66F8\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002",
            paymentTimingExplanation: '※ 支払いタイミングにより手数料が異なります。詳しくは画面下部の価格シュミレーターをご参照下さい。',
            oneTimeUpfrontRateConstraintByBagAmount: '（2袋以上のご予約に限ります）',
            oneTimeUpfrontRateConstraintByWeight: '（120Kg以上のご予約に限ります）',
            deliveryMethodExplanation: "\u203B \u5F0A\u793E\u5009\u5EAB\u3078\u306E\u5165\u5EAB\u65E5\u304B\u3089\u7FCC\u3005\u6708\u306E1\u65E5\u304B\u3089\u30011kg\u3042\u305F\u308A\u6708\u984D{{unitPrice}}\u306E\u4FDD\u7BA1\u6599\u304C\u767A\u751F\u3057\u307E\u3059\u3002",
            oneTimeUpfrontRateByBagAmount: '({{ percentage }}割引 ※2袋以上の予約に限り)',
            oneTimeUpfrontRateByWeight: ' | -{{ percentage }} 割引',
            paymentTimingNegativeRate: ' | -{{ percentage }} 割引',
            paymentTimingPositiveRate: ' | 支払手数料 {{ positive }}{{ percentage }}',
            addressExplanation: '※ マンション名・部屋番号等の記入漏れにご注意下さい。',
            emailExplanation: '※ メールアドレスの入力間違いにご注意下さい。',
            deliveryTimeEtcExplanation: '※ 配送時間のご指定など、ご要望にお応えしかねる場合もございます。ご了承下さい。',
            sample: 'サンプル',
            sampleOrder: 'サンプル請求',
            outOfSamples: 'サンプル在庫切れ',
            sampleOrdered: '予約済み',
            bidSubmitted: '入札済み',
            sampleOrderableCount: 'サンプル請求できるロット数',
            inputAddress: '住所入力へ',
            simulateAndInputAddress: '価格詳細・住所入力へ',
            simulation: '価格シミュレーション',
            sampleOrderCaption: '以下のLOTのサンプルを予約します',
            comment: 'コメント',
            commentHelp: '※ コメントは生産者や他のロースターに共有されます',
            translation: '※ コメントは英語、スペイン語、日本語、中国語、韓国語へ翻訳することができます。',
            postComment: 'コメントする',
            updateComment: 'コメントを更新する',
            deleteComment: 'コメントを削除する',
            noComments: 'コメントがありません',
            cuppingScoreHelpText: 'SCAカッピングフォームで評価した点数をご記入下さい',
            more: 'もっと見る',
            ordered: '予約済み',
            addInvoice: '請求書作成',
            preOrderExplanation: '予約受付期間は {{startedAt}} - {{endedAt}} を予定しています。',
            countdownToOrder: '予約開始まであと {{countdown}} です',
            confirmationOfBuyPartial: 'Lot:{{lotNumber}}が入札した数量に満たない場合は落札しない',
            auctionBadgeExplanation: "\u3053\u306E\u30ED\u30C3\u30C8\u306F\u30D6\u30E9\u30A4\u30F3\u30C9\u30AA\u30FC\u30AF\u30B7\u30E7\u30F3\u306B\u51FA\u54C1\u3055\u308C\u3066\u3044\u307E\u3059\u3002\n      \u5E0C\u671B\u3059\u308B\u8CFC\u5165\u4FA1\u683C\u3068\u500B\u6570\u3092\u5165\u529B\u3057\u3066\u4E0B\u3055\u3044\u3002\n      \u30B9\u30BF\u30FC\u30C8\u4FA1\u683C\u3092\u4E0A\u56DE\u3063\u305F\u91D1\u984D\u306F\u3001\u30AA\u30FC\u30AF\u30B7\u30E7\u30F3\u30DC\u30FC\u30CA\u30B9\u3068\u3057\u3066\u751F\u7523\u8005\u306B\u652F\u6255\u308F\u308C\u307E\u3059\u3002\n      \u30AA\u30FC\u30AF\u30B7\u30E7\u30F3\u306E\u7D50\u679C\u306F\u5F8C\u65E5\u30E1\u30FC\u30EB\u3067\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002\n      \u30D0\u30C3\u30B8\u306E\u6570\u5B57\u306F\u73FE\u5728\u306E\u8CFC\u5165\u5E0C\u671B\u4EF6\u6570\u3067\u3059\u3002",
            okagesamaNoMoriPrice: '※ 参画費用 {{ priceUsd }} (約 {{ price }})',
            okagesamaNoMoriPriceText: '(為替によって参画費用が変わることがあります。)',
            sampleStats: 'ロースターが注目',
            preorderStats: 'ロースターが購入',
        },
        ordersPage: {
            title: '予約一覧',
            detailsTitle: '予約詳細',
        },
        sampleOrdersPage: {
            title: 'サンプル請求一覧',
        },
        register: {
            accept: '規約に同意する',
        },
        orderedOfferLists: {
            title: '予約されたオファーリスト',
        },
        sampleOrders: {
            title: 'サンプル請求一覧',
            import: 'サンプル請求インポート',
        },
        sampleOrderedOfferLists: {
            title: 'サンプル請求されたオファーリスト',
        },
        orderDetail: {
            orderItemsTableTitle: '予約ロット一覧',
            bidsTableTitle: '入札ロット一覧',
            changeStatus: 'ステータス更新',
            preOrderRequestCreateOrEdit: 'リクエストを作成または編集する',
        },
        sampleOrderDetail: {
            requestedLotNumbers: 'サンプル請求したLot#',
        },
        invoice: {
            title: '予約 {{orderIds}} の請求書',
            billingTo: '請求先',
            billingAddress: '請求先住所',
            transparencyInformation: {
                farm: '生産者',
                farmExplanation: '生産者の情報は<1>こちら</1>をご覧ください。',
                mill: '精製所',
                millExplanation: '小規模生産者から購入したコーヒーチェリーやパーチメントはローカルのミルで精製されます。こちらには生産国の国内輸送費用、通関費用も含まれています。',
                auctionBonus: 'オークションボーナス',
                auctionBonusExplanation: 'ブラインドオークションの購入価格のうち、スタート価格を上回った金額です。この金額はオークションボーナスとして生産者に支払われます。',
                shippingFee: '運送費用',
                shippingFeeExplanation: '運送費用と輸入費用（通関費用、植物検疫申請料など）の合計です。',
                importTax: '輸入消費税',
                importTaxExplanation: '運送費用と商品代金の合計の{{ importTaxRate }}です。',
                typica: 'TYPICA',
                typicaExplanationForExclusiveLot: 'TYPICAの報酬です。（{{exclusiveTypicaHandlingRate}}）',
                typicaExplanationByBagCount: 'TYPICAの報酬です。（5袋未満{{ lessThan5Bags }}、5袋以上{{ moreThan5Bags }}、10袋以上{{ moreThan10Bags }}、50袋以上{{ moreThan50Bags }}）',
                typicaExplanationByWeight: 'TYPICAの報酬です。（300Kg未満{{ lessThan300Kg }}、300Kg以上{{ moreThan300Kg }}、600Kg以上{{ moreThan600Kg }}、3,000Kg以上{{ moreThan3000Kg }}）',
                typicaExplanationForTypicaSelection: 'TYPICAの報酬です。（40%）',
                typicaExplanationForTypicaSelectionByWeightV1: 'TYPICAの報酬です。（300Kg未満 40%、300Kg以上 35%、600Kg以上 30%、3,000Kg以上 25%）',
                typicaExplanationForTypicaSelectionByWeightV2: 'TYPICAの報酬です。（300Kg未満 35%、300Kg以上 25%、600Kg以上 20%、3,000Kg以上 15%）',
                consumptionTaxExplanation: '課税対象の国内費用と手数料の{{ taxRate }}です。',
                vatReverseChargeExplanation: 'VAT Reversed Charge 0% が適用されています。',
                oldPriceVersionKgPriceNotice: '「掛け払い手数料(非課税), 前払い割引」および「サービス料(非課税)」を除いたkg単価です。',
                newPriceVersionKgPriceNotice: '「支払いタイミングによる割引または手数料」を除いたkg単価です。',
                specialTypicaDiscount: '割引',
                specialTypicaDiscountExplanation: 'ご注文に適用された割引額の合計です。',
                shippingFeeForJp: '海外輸送費用',
                shippingFeeExplanationForJp: '積地港から揚地港・空港までにかかる費用です。',
                importTaxForJp: '輸入・運送費用',
                importTaxExplanationForJp: '揚地港から倉庫までにかかる運送・輸入費用（通関費用、植物検疫申請料など）の合計です。',
                consumptionTaxExplanationForJp: '生豆に対して8%、海外輸送費用・その他費用に対して10%の課税対象額の合計です。',
                CoffeeCherryExplanation: '備考',
                negativeBreakdownCoffeeCherryExplanation: 'コーヒーチェリーの高騰によって{{producerName}}の利益にマイナスが生じています。彼らはロースターとの長期的な関係性の構築を最重要視し、マイナスを受け入れて平年並みの価格を保つことを選択しました。',
            },
            paidStatus: '支払い状態',
            paidMessage: '{{paidDate}} にお支払い済',
            unpaidMessage: '{{expiredDate}} までにお支払いください',
            changePaymentMethod: '支払い方法を変更する',
            vatrcHelp: 'プロフィール画面でVAT番号を入力するとVAT Reversed Chargeが適用されます。',
        },
        adminUsers: {
            title: 'ユーザー管理',
        },
        adminRoasters: {
            title: 'ロースター一覧',
            typicaShareRatioCalculatedAt: 'TYPICAシェア率計算日時',
        },
        adminRoasterDetail: {
            title: '{{roaster}}の詳細',
        },
        adminProducers: {
            title: 'プロデューサー一覧',
        },
        adminProducerDetail: {
            title: '{{producer}}の詳細',
        },
        countryInformations: {
            title: '生産国情報',
        },
        roasterCountries: {
            title: '販売国',
        },
        adminOrder: {
            title: '代理予約',
            selectRoaster: 'ロースターを選択してください',
        },
        warehouses: {
            title: '倉庫管理',
        },
        warehouseItems: {
            title: '倉庫在庫',
            deliveryRequest: '配送依頼',
            addressInfo: '配送先住所',
            selectItems: '配送依頼したいLotを選択してください',
            explainationForQuantity: '数量は荷姿単位で表示されておりご予約時の発注単位とは異なります',
            editDeliveryRequest: {
                caption: '配送スケジュールの調整が必要ですか？',
                button: '配送スケジュールを編集',
            },
        },
        deliveryRequests: {
            title: '配送依頼一覧',
            import: '配送依頼のインポート',
        },
        deliveryRequestDetail: {
            title: '配送依頼詳細',
            basicInfo: '基本情報',
            editForm: '編集フォーム',
        },
        newDeliveryRequest: {
            title: '配送依頼作成',
        },
        roasterWarehouseItems: {
            requestable: '配送可能',
            delivered: '納品済',
            delivering: '配送中',
        },
        offerListForum: {
            translateMessage: 'メッセージを翻訳する',
            changeTranslationLanguage: '翻訳言語を変更する',
            languages: {
                en: '英語',
                es: 'スペイン語',
                ja: '日本語',
                zh: '中国語',
                ko: '韓国語',
            },
        },
        monthlyClosing: {
            title: '月締め一覧',
            createButton: '月締め処理',
        },
        balanceSheetEntry: {
            title: '経理',
            advanceReceived: '前受金',
        },
        offices: {
            title: '拠点',
        },
        invoicePayment: {
            title: '請求書「{{invoiceTitle}}」 へのお支払い',
            suspendedMessage: "\u5927\u5909\u7533\u3057\u8A33\u3042\u308A\u307E\u305B\u3093\u3002\n\n\u73FE\u5728\u6C7A\u6E08\u30B7\u30B9\u30C6\u30E0\u306E\u79FB\u884C\u306B\u4F34\u3044\u3001\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u3067\u306E\u652F\u6255\u3044\u3092\u4E00\u6642\u505C\u6B62\u3057\u3066\u3044\u307E\u3059\u3002\n\u304A\u624B\u6570\u3067\u3059\u304C\u6C7A\u6E08\u30B7\u30B9\u30C6\u30E0\u306E\u79FB\u884C\u5B8C\u4E86\u5F8C\u306B\u304A\u652F\u6255\u3044\u3044\u305F\u3060\u304F\u304B\u3001\u304A\u6025\u304E\u306E\u5834\u5408\u306F\u9280\u884C\u632F\u308A\u8FBC\u307F\u306B\u3088\u308B\u304A\u652F\u6255\u3044\u3092\u3088\u308D\u3057\u304F\u304A\u9858\u3044\u3044\u305F\u3057\u307E\u3059\u3002\n",
        },
        transportToWarehouse: {
            waterActivity: '水分活性値',
            moistureContent: '水分量',
        },
        adminAuction: {
            title: '{{offerListName}} / {{lotNumber}}のオークション状況',
            auctionClosed: 'このオークションはすでに終了しています',
            auctionOpened: 'このオークションは開催中です',
            closeAuction: 'オークションを終了する',
            confirmation: "\u30AA\u30FC\u30AF\u30B7\u30E7\u30F3\u3092\u7D42\u4E86\u3057\u307E\u3059\u3002\u5165\u672D\u306E\u5BE9\u67FB\u306F\u30AA\u30FC\u30AF\u30B7\u30E7\u30F3\u3092\u7D42\u4E86\u3059\u308B\u3068\u3067\u304D\u307E\u305B\u3093\u3002\n\u672C\u5F53\u306B\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F",
        },
        roasterBids: {
            title: '入札一覧',
        },
        roasterAuction: {
            title: '{{offerListName}} / {{lotNumber}}のオークション結果',
            bidQuantity: '落札した数量',
            roasterAuctionResult: 'あなたの落札結果',
            auctionResult: '全体の落札結果',
        },
        adminCreateTypicaStockItems: {
            title: 'TYPICAセレクション作成',
        },
        adminTypicaStockItems: {
            title: 'TYPICAセレクション一覧',
            helpQuantity: '在庫の総数です。この値はShipping instructionなどの契約書を作成時に反映されます。',
            helpRemainingQuantity: '数量 - 予約数 + 在庫調整数量',
            helpAdjustmentQuantity: '在庫数の調整用(サンプル請求用等で在庫を減らしたいときなどに設定してください)',
            helpSampleRemainingQuantity: 'サンプル総数 - サンプル予約数',
        },
        adminNewTypicaStockOrder: {
            title: 'TYPICAセレクションの予約',
        },
        adminTypicaStockOrders: {
            title: 'TYPICAセレクション予約一覧',
        },
        adminTypicaStockSampleOrders: {
            title: 'TYPICAセレクションサンプル請求一覧',
        },
        adminSalesContractAndAuctionBonusInvoice: {
            title: 'Sales Contract / Auction Bonus Invoice',
        },
        adminSalesContractBankAccount: {
            title: 'SalesContractの銀行口座情報',
        },
        producerBankAccounts: {
            title: '銀行口座情報一覧',
            edit: '銀行口座情報編集',
            new: '銀行口座情報作成',
        },
        producerOkagesamaNoMori: {
            title: 'OKAGESAMA',
        },
        adminRoasterSalesReward: {
            title: 'ロースターの販売報酬',
            netWeight: '重量',
            quantity: '数量',
        },
        typicaSelection: {
            title: 'TYPICAセレクション',
            order: '予約内容の詳細を見る',
            sampleOrderPeriod: '常時',
            orderPeriod: '常時',
            paymentPeriod: '納品後かけ払い',
            estimatedDeliveryPeriod: '予約後１週間程度',
            sampleOrder: 'サンプル請求はこちらから',
            orderFormStepper: {
                order: '支払い & 請求先住所',
                deliveryRequest: '配送指定',
            },
            tooltip: {
                invalidDeliveryRequestGroup: {
                    oneTime: {
                        body1: '配送指定日が空欄です',
                        body2: '配送指定日をご指定ください',
                    },
                    installment: {
                        body1: '配送依頼可能なロットが残っています',
                        body2: '分割納品ですべての配送時期をご指定ください',
                    },
                },
                isNotWarehousing: {
                    body1: 'まだ入庫されていません',
                    body2: '入庫済みのロット以外は配送時期を設定できません',
                },
                inValidDeliveryRequestItemsAndRequestDate: '配送数または配送指定日を入力してください',
            },
        },
        preOrderRequest: {
            title: 'リピート購入リクエスト一覧',
            new: 'リピート購入リクエスト作成',
            requestedOffer: 'リピート購入リクエスト済みLot',
            lotNumberBlank: '同一オファーリスト内からリクエストする',
        },
        roasterAddresses: {
            title: 'アドレス帳管理',
            billingAddresses: '請求宛住所',
            deliveryAddresses: '配送先住所',
        },
        cuppingComments: {
            title: 'カッピングサマリー',
            commentedBy: 'カッピングロースター',
            otherRoasters: '他の{{ count }}件のロースターを表示',
        },
        createCuppingComment: {
            title: 'コメントを作成',
        },
        deliveryRequestItemsAndRequestDateForm: {
            title: '配送指定',
            subheaders: {
                oneTime: 'お届け目安の時期に一括納品で納品いたします。',
                installment: 'お届け目安の時期から最大３回に分割して納品いたします。',
                installmentCaption: 'お届け目安: 予約後1週間程度',
            },
            type: {
                oneTime: '一括納品',
                installment: '分割納品',
            },
            changeTimings: '{{ timing }}に変更',
            buttons: {
                new: '配送時期を設定',
                add: '配送時期を追加',
            },
            captions: {
                datePicker: {
                    fastestDelivery: '※空欄の場合、最短での配送になります。',
                    main: {
                        deliveryDateExplanation: '※本日を含む{{ startWeek }}後の日付から、配送依頼日を5ヶ月以内の期間でご指定いただけます。',
                        startWeek1: '1週間',
                        startWeek2: '2週間',
                    },
                    sub: {
                        europe: '※配送指定日について、地域によって実際の配送が平均2週間ほど遅延することがありますので、お早めの配送日指定を推奨しております。あらかじめご了承ください。',
                        etc: '※配送指定日について、地域によって実際の配送が1週間ほど遅延することがありますので、お早めの配送日指定を推奨しております。あらかじめご了承ください。',
                    },
                },
                card: '※新鮮な状態でお届けするために一括納品をお勧めしています。ご都合に応じて分割納品を選択できます。',
            },
            dialog: {
                title: '配送時期',
            },
        },
        adminWarehouseHoliday: {
            title: '倉庫休日設定',
        },
        exportCsv: {
            title: 'CSVダウンロード',
        },
    },
    labels: {
        stock: '数量',
        stockUnit: '袋',
        lotRef: 'LOT',
        offerListSummary: 'オファーサマリー',
        farmWithLink: '農園',
        curatorName: 'キュレーター名',
        seller: '出品者',
        story: '物語',
        material: '資料',
        period: 'オファー期間',
        activeOfferLists: '公開中',
        preparingOfferLists: '公開準備中',
        expiredOfferLists: '受付終了',
        noData: 'データが見つかりませんでした',
        paymentTimingOnAdmin: '支払時期',
        fullAddress: '住所',
        deliveryItems: '配送リスト(Lot: 配送数)',
        all: 'すべて',
        inStock: '在庫あり',
        forum: '掲示板',
        forumDisplayName: '掲示板の表示名',
        taxed: '課税対象になります',
        paymentTimingHandlingFee: {
            negativeValue: '割引',
            positiveValue: '支払手数料',
        },
        paid: '支払い済',
        exported: '輸出時',
        imported: '輸入時',
        uploadContract: 'アップロードする契約書を選択してください',
        uploadDocuments: 'アップロードする資料を選択してください',
        uploadBusinessNumberKrdocument: '画像ファイルを選択してください',
        selectFoundingCurator: 'ファウンディングキュレーター名を入力してください',
        pending: '未定',
        newRoasterCampaignDiscount: '初回購入限定割引',
        couponTarget: 'クーポン適用中',
        newRoasterCampaignUnderway: '初回購入限定キャンペーン実施中！',
        agree: '上記の注意事項に同意する',
        memo: 'メモ',
        tradeCountryUsages: '用途',
        tradeCountryProcessings: 'プロセス / 精製方法',
        tradeCountryPriceRanges: '価格帯 /1kg',
        uneditableJoinedInOkagesamaNoMori: '公開中または公開準備完了のオファーリストがあるため「OKAGESAMAに参画する」は変更できません',
        contributedToOkagesamaNoMori: '※ OKAGESAMAに参画済みです',
        default: 'デフォルト',
        billingAddress: '請求先住所',
        deliveryAddress: '配送先住所',
        deliveryRequestFormRequestDate: '配送指定日',
        fastestDeliveryRequest: '最短での配送',
        deliveryRequestByDate: '日付指定での配送',
        includesItems: '明細を含める',
        bulkDownloadMode: '一括ダウンロードモード',
        miscFeeForJp: 'その他手数料 *2',
        taxNodeForJpCalculation: '*1 8%課税対象 / *2 10%課税対象 / *3 不課税対象',
    },
    buttons: {
        yes: 'はい',
        no: 'いいえ',
        create: '作成する',
        update: '更新する',
        delete: '削除',
        cancel: '取消',
        apply: '設定',
        complete: '完了',
        resetPassword: 'パスワードをリセットする',
        changePassword: 'パスワードを変更する',
        reconfirmEmail: '確認メールを再送',
        chooseFile: 'ファイルを選択してください',
        upload: 'アップロード',
        calculateFixed: '最終価格を確定する',
        cancelFixed: '最終価格の確定をキャンセルする',
        pay: '入金確認済みにする',
        unpay: '入金確認済みを解除',
        downloadInvoice: '請求書ダウンロード',
        salesContractDownloadPdf: 'Sales Contract ダウンロード',
        auctionBonusInvoiceDownloadPdf: 'Auction Bonus Invoice ダウンロード',
        downloadCsv: 'CSVダウンロード',
        deliveryRequest: '配送依頼する',
        processing: '処理中...',
        import: 'インポート',
        addItem: '追加',
        createContracts: '契約書作成',
        changeStatusTo: '{{status}}にする',
        setBankAccount: '銀行口座情報を設定する',
        bankAccount: '銀行口座情報',
        selectFoundingCurator: 'ファウンディングキュレーターを選択する',
        changeFoundingCurator: 'ファウンディングキュレーターを変更する',
        deleteFoundingCurator: 'ファウンディングキュレーターを取り消す',
        salesReward: '販売報酬',
        manageCommunityManager: 'コミュニティマネージャーを設定する',
        stripePayment: '支払う',
        taiwanApiResponse: {
            resend: '再送信(統一発票)',
            update: '送信せずに送信完了にする(統一発票)',
            destroy: '送信完了を削除(統一発票)',
        },
        priceDetail: '予約内容の詳細を見る',
        setAsDefault: 'デフォルトに設定',
        selectAll: 'すべて選択',
        deselectAll: 'すべて選択解除',
        next: '次へ',
        updateNow: '今すぐ更新する',
        downloadOffersCsv: '全ロット情報のダウンロード',
    },
    links: {
        login: 'ログインはこちらから',
        register: '新規登録はこちらから',
        resetPassword: 'パスワードを忘れた場合はこちら',
        reconfirmEmail: '確認メールを再送はこちらから',
        back: '戻る',
        payFromHere: 'お支払いはこちらから',
        story: '物語',
        movie: '動画',
        privacy_policy: 'プライバシーポリシー',
        specified_commercial_transactions_law: '特定商取引法に基づく表示について',
        tos: '利用規約',
        trackingUrl: '輸送状況',
        cookiePolicy: 'Cookieポリシー',
    },
    messages: {
        registerSuccess: 'メールアドレスの有効性の確認のため{{ email }}にメールをお送りしました。メールに記載されているリンクより登録を完了させて下さい。',
        confirmationSuccess: 'メールアドレスの認証を確認しました。設定されたメールアドレス・パスワードでログインして下さい。',
        unlockSuccess: 'アカウントをロック解除しました。',
        resetPasswordSuccess: 'パスワードリセットを受け付けました。メールでご連絡しますのでご確認ください。',
        accountUpdateSuccess: 'アカウント情報を編集を受け付けました。メールでご連絡しますのでご確認ください。',
        changePasswordSuccess: 'パスワードを変更しました。',
        reconfirmEmailSuccess: '確認メールを再送を受け付けました。メールでご連絡しますのでご確認ください。',
        invalidEmail: '正しいEメールを入力してください',
        invalidPostalCode: '郵便番号は数字のみで入力してください',
        loginSuccess: 'ログインしました',
        logoutSuccess: 'ログアウトしました',
        uploadSuccess: 'CSVアップロードが成功しました',
        createSuccess: '作成しました',
        updateSuccess: '更新しました',
        deleteSuccess: '削除しました',
        updateFailure: '失敗しました',
        deleteConfirm: '削除します。本当によろしいですか？',
        rejectConfirm: '審査落ちでキャンセルにします。本当によろしいでしょうか？',
        bidCancelConfirm: '入札を取り消しにしてキャンセルにします。本当によろしいでしょうか？',
        orderSuccess: '注文しました',
        typicaStockOrderSuccess: '注文しました。すでに入庫済みのものは倉庫在庫一覧から配送依頼いただけます。',
        sampleOrderSuccess: 'サンプルを予約しました',
        deliveryRequestSuccess: '配送依頼しました。発送準備が整い次第、改めてご連絡させていただきます',
        cancelConfirm: 'キャンセルを取り消すことはできません。本当によろしいですか？',
        calculateFixed: "\u30ED\u30FC\u30B9\u30BF\u30FC\u304B\u3089\u306E\u4E88\u7D04\u7533\u8FBC\u307F\u3092\u627F\u8A8D\u3057\u3001\u58F2\u8CB7\u5951\u7D04\u3092\u6210\u7ACB\u3055\u305B\u307E\u3059\u3002\n\u91D1\u984D\u306B\u9593\u9055\u3044\u304C\u306A\u3044\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\n\u6700\u7D42\u4FA1\u683C\u3092\u78BA\u5B9A\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F",
        calculateFixedSuccess: '対象の予約の最終価格を確定しました。',
        cancelFixed: "\u6210\u7ACB\u6E08\u307F\u306E\u30ED\u30FC\u30B9\u30BF\u30FC\u3068\u306E\u58F2\u8CB7\u5951\u7D04\u3092\u7834\u68C4\u3057\u307E\u3059\u3002\n\u5951\u7D04\u7834\u68C4\u306B\u306F\u30EA\u30B9\u30AF\u304C\u751F\u3058\u307E\u3059\u3002\n\u672C\u5F53\u306B\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3059\u304B\uFF1F",
        cancelFixedSuccess: '最終価格の確定をキャンセルしました。',
        commentSuccess: 'コメントしました',
        deleteCommentConfirmTitle: 'コメントの削除',
        deleteCommentConfirmBody: 'コメントを削除します。本当によろしいですか？',
        changePasswordTokenError: 'パスワードリセットの有効期限がきれています。再度リセットしてください。',
        deleteInvoiceConfirmTitle: '請求書の削除',
        deleteInvoiceConfirmBody: '請求書を削除します。本当によろしいですか？',
        deleteInvoiceItemConfirmTitle: '請求明細の削除',
        deleteInvoiceItemConfirmBody: '請求明細を削除します。本当によろしいですか？',
        sendInvoiceMailConfirmTitle: 'メール通知',
        sendInvoiceMailConfirmBody: 'ロースターへ請求書が発行されたことをメールします。本当によろしいですか？',
        sentSuccess: 'メールを送信しました。',
        payConfirmTitle: '入金確認済みにする',
        payConfirmBody: '入金確認済みにします。本当によろしいですか？',
        unpayConfirmTitle: '入金確認済みを解除する',
        unpayConfirmBody: '入金確認済みを解除します。本当によろしいですか？',
        nRowsSelected: '{0}件を選択中です',
        noDeliveryRequest: '配送依頼がありません',
        invalidOrderCombination: 'サンプル請求と予約は同時にはできません。',
        orderExplanationTitle: '予約に関する注意事項',
        sampleOrderExplanationTitle: 'サンプル請求に関する注意事項',
        auctionOrderExplanationTitle: 'オークション予約に関しての注意',
        sampleOrderExplanationBody: "\u6570\u306B\u9650\u308A\u304C\u3042\u308B\u305F\u3081\u30B5\u30F3\u30D7\u30EB\u30EA\u30AF\u30A8\u30B9\u30C8\u306F\u3054\u8CFC\u5165\u5E0C\u671B\u8005\u69D8\u306B\u9650\u3089\u305B\u3066\u9802\u304D\u307E\u3059\u3002\n\u307E\u305F\u3001\u5168\u56FD\u5404\u5730\u3067\u5168\u30ED\u30C3\u30C8\u3092\u304A\u8A66\u3057\u9802\u3051\u308B\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u30AB\u30C3\u30D4\u30F3\u30B0\u3092\u958B\u50AC\u3057\u3066\u3044\u307E\u3059\u3002\n\u8A73\u3057\u304F\u306F\u30E1\u30FC\u30EB\u3067\u306E\u3054\u6848\u5185\u3092\u3054\u78BA\u8A8D\u4E0B\u3055\u3044\u3002",
        deliveryTimeExplanationTitle: '配送に関する注意事項',
        deliveryTimeExplanationForUsBody: "* There are additional costs associated with last-mile delivery from RPM warehouse in NJ via Accurate Transport.\n    * Please click <0>here</0> for delivery charges and <1>here</1> for delivery time.\n    * Arranging your own local shipping company or picking up at the warehouse are also possible. If so, please indicate this in the Note.\n    * Delivery could be delayed by logistical problems.\n    * Please feel free to ask if you have any questions.",
        deliveryTimeExplanationBody: "\u203B \u56FD\u5185\u306E\u914D\u9001\u6599\u91D1\u306F\u5225\u9014\u8ACB\u6C42\u3055\u305B\u3066\u9802\u304D\u307E\u3059\u3002\n\u203B \u51FA\u5EAB\u6BCE\u306B\u624B\u6570\u6599500\u5186\uFF08\u7A0E\u629C\uFF09\u3092\u7533\u3057\u53D7\u3051\u307E\u3059\u3002\n\u203B \u6D41\u901A\u7D4C\u8DEF\u306E\u4E8B\u60C5\u306A\u3069\u306B\u3088\u3063\u3066\u7D0D\u54C1\u4E88\u5B9A\u65E5\u304B\u3089\u9045\u308C\u308B\u5834\u5408\u3082\u3054\u3056\u3044\u307E\u3059\u3002\n\u203B \u3054\u4E0D\u660E\u306A\u70B9\u304C\u3054\u3056\u3044\u307E\u3057\u305F\u3089\u3001\u304A\u6C17\u8EFD\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002\n\u203B \u795D\u65E5\u306E\u914D\u9001\u4F9D\u983C\u306F\u53D7\u3051\u4ED8\u3051\u3066\u304A\u308A\u307E\u305B\u3093\u3002\n\u203B 17\u6642\u307E\u3067\u306E\u914D\u9001\u4F9D\u983C\u306F2\u55B6\u696D\u65E5\u5F8C\u306B\u51FA\u8377\u3055\u308C\u307E\u3059\u3002\n\u203B 17\u6642\u4EE5\u964D\u306E\u914D\u9001\u4F9D\u983C\u306F3\u55B6\u696D\u65E5\u5F8C\u306B\u51FA\u8377\u3055\u308C\u307E\u3059\u3002\n\u203B \u7D0D\u54C1\u65E5\u76EE\u5B89\u306F\u3053\u3061\u3089\u306E<0>\u30D5\u30A1\u30A4\u30EB</0>\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002",
        orderExplanationForUsBody: "* Please refer to <0>our terms and conditions</0> before proceeding with pre-orders.\n\n    * Pre-order pricing is ex-warehouse.\n    There are additional costs associated with last-mile delivery from RPM warehouse in NJ via Accurate Transport.\n    Please see <1>this file</1> for delivery costs by destination in NYC area.\n    Kindly note that shipping fees for delivery outside of New York, New Jersey, Maryland, Delaware, and Washington D.C. will be confirmed once we obtain a quote from the delivery company.\n\n    * An estimated delivery date may be delayed due to circumstances in production areas or distribution channels.\n\n    * The quality of the product shall be the same as the sample.\n\n    * As green coffee production is strongly affected by the situation and climate of production areas, conditions may be subject to change. Please note that this pre-order does not immediately guarantee the conclusion of your order. We will send you confirmation of your order after the end of a pre-order period.",
        orderExplanationBody: "\u203B \u3054\u4E88\u7D04\u306E\u524D\u306B\u5FC5\u305A<0>\u5229\u7528\u898F\u7D04</0>\u3092\u3054\u78BA\u8A8D\u4E0B\u3055\u3044\u3002\n\n\u203B \u5225\u9014\u3001\u56FD\u5185\u9001\u6599\u304C\u767A\u751F\u3057\u307E\u3059\u3002\n\n\u203B \u751F\u7523\u5730\u3084\u8F38\u9001\u306E\u72B6\u6CC1\u306B\u3088\u3063\u3066\u3001\u304A\u5C4A\u3051\u76EE\u5B89\u304B\u3089\u9045\u5EF6\u3059\u308B\u5834\u5408\u3082\u3054\u3056\u3044\u307E\u3059\u3002\n\n\u203B \u5546\u54C1\u306E\u54C1\u8CEA\u306F\u30B5\u30F3\u30D7\u30EB\u306B\u6E96\u3058\u307E\u3059\u3002\n\n\u203B \u30B3\u30FC\u30D2\u30FC\u751F\u8C46\u306E\u751F\u7523\u306F\u3001\u751F\u7523\u5730\u306E\u72B6\u6CC1\u3084\u6C17\u5019\u306E\u5F71\u97FF\u3092\u5F37\u304F\u53D7\u3051\u308B\u305F\u3081\u3001\u6761\u4EF6\u304C\u5909\u52D5\u3059\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u672C\u4E88\u7D04\u306F\u4E88\u7D04\u6210\u7ACB\u3092\u78BA\u7D04\u3059\u308B\u3082\u306E\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u4E88\u7D04\u6210\u7ACB\u306B\u3064\u3044\u3066\u306F\u3001\u4E88\u7D04\u671F\u9593\u7D42\u4E86\u5F8C\u306B\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002",
        createdInvoices: '{{count}} 件の請求書が作成されました',
        orderNotStarted: '予約受付開始は {{ startedAt }} からです',
        createContractsTitle: '契約書の作成',
        createContractsBody: "\u5951\u7D04\u66F8\u306E\u96DB\u5F62\u30C7\u30FC\u30BF\u3092\u4F5C\u6210\u3057\u307E\u3059\u3002\nTYPICA\u5728\u5EAB\u306E\u4F5C\u308A\u5FD8\u308C\u306A\u3069\u304C\u306A\u3044\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\n\u4F5C\u6210\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3057\u3087\u3046\u304B\uFF1F",
        changeContractStatusToPublished: '発行済みにします。発行済にするとプロデューサーへ公開され、メールで通知されます。本当によろしいですか？',
        changeContractStatusToDraft: '発行準備中に戻します。本当によろしいですか？',
        salesContractDownloadExplanationTitle: 'SalesContractのダウンロードにあたって',
        salesContractDownloadExplanationBody: "SalesContract\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308B\u524D\u306B\u3001\u9280\u884C\u53E3\u5EA7\u60C5\u5831\u3092\u8A2D\u5B9A\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\n\u9280\u884C\u53E3\u5EA7\u60C5\u5831\u3092\u9078\u629E\u3057\u3001\u8FFD\u52A0\u3067\u6CE8\u610F\u4E8B\u9805\u306A\u3069\u304C\u3042\u308B\u5834\u5408\u306F\u8A18\u8F09\u3057\u3066\u304F\u3060\u3055\u3044",
        addBankAccountInformation: "SalesContract\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308B\u305F\u3081\u306B\u306F\u3001\u9280\u884C\u53E3\u5EA7\u60C5\u5831\u3092\u767B\u9332\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\n\u4E0B\u8A18\u306EURL\u304B\u3089\u9280\u884C\u53E3\u5EA7\u60C5\u5831\u3092\u767B\u9332\u3057\u3066\u304F\u3060\u3055\u3044",
        createBankAccount: '銀行口座情報作成しました',
        orderedOfferNotExist: '予約したLotはまだありません',
        stripeConfirmBody: '決済します。本当によろしいですか？',
        updateSuccessInvoicePaid: 'お支払いが完了しました。請求書が支払い済みになるまでに少し時間がかかる場合があります。ご了承ください。',
        deliverySampleWarningMessage: 'サンプルの発送は、商品が入庫してからとなります。入庫予定は{{ approvalDate }}になります。',
        deliverySampleWarningConfirmationMessage: '以下のサンプルの発送は、商品が入庫してからとなります。',
        contactToTypicaMessage: 'お問い合わせは以下のメールアドレスよりお問い合わせ下さい',
        contactToTypicaMailSubject: 'TYPICA Direct Trade Platform',
        selectColumns: '表示する列を選択してください',
        exchangeRateMoreThanHighestRateOnPrevMonth: '前月の最高レート({{ rate }})を超えています。よろしいですか？',
        exchangeRateLessThanLowestRateOnPrevMonth: '前月の最低レート({{ rate }})未満です。よろしいですか？',
        updateRequired: '新しいバージョン {{ version }} が見つかりました。５秒後に更新します。',
        newPlatformRegisterNotice: '2024年8月6日より新プラットフォームに移行しました。新規登録の希望の方は、<0>こちら</0>から登録をお願いします。',
        newPlatformNotice: '2024年8月6日より新プラットフォームに移行します。<0>こちら</0>をご利用ください。',
        newPlatformSampleNotice: '新プラットフォームのサンプル請求一覧は<0>こちら</0>です。',
        newPlatformOrderNotice: '新プラットフォームの予約一覧は<0>こちら</0>です。',
        newPlatformInvoiceNotice: '新プラットフォームの請求書は<0>こちら</0>です。',
        newPlatformProfileNotice: "\u3053\u3061\u3089\u3067\u66F4\u65B0\u3055\u308C\u305F\u60C5\u5831\u306F\u3001\u65B0\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0\u306B\u306F\u81EA\u52D5\u5F15\u304D\u7D99\u304E\u3055\u308C\u307E\u305B\u3093\u3002\n\u5927\u5909\u304A\u624B\u6570\u3067\u3059\u304C\u3001<0>\u65B0\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0</0>\u3078\u306E\u66F4\u65B0\u3082\u304A\u9858\u3044\u3044\u305F\u3057\u307E\u3059\u3002",
    },
    errors: {
        isRequired: '{{ field }}を入力してください',
        invalid: '{{ field }}は不正な値です',
        positive: '{{ field }}は1以上を入力してください',
        integer: '{{ field }}は半角数字で入力してください',
        decimal: '{{ field }}は半角数字及び.(小数点)で入力してください',
        alphanumeric: '{{ field }}は半角英数字で入力してください',
        invalidPostalCode: '郵便番号は半角英数字７文字で入力してください',
        invalidCity: '市区町村は全角12文字以下で入力してください',
        invalidAddress: '{{ field }}は全角{{ fullWidthMaxLength }}文字/半角{{ halfWidthMaxLength }}文字以下で入力してください',
        purchaseLimitError: '本ロットの購入上限は{{limit}}個となります',
        lowestBidFobPriceError: '入力された価格がスタート価格を下回っています',
        totalFeeUpperLimitError: 'クレジットカード決済の上限額を超えています。銀行振込に変更するか、合計金額を8桁以下になるように調整してください',
        noStock: '在庫が足りません',
        sameTypicaStockItemExists: '同一のLot、倉庫の組み合わせがすでに存在します',
        mustOverOfferMinOrderWeight: 'Lotの発注単位 {{ minOrder }}以上の重量を入力してください',
        notSelectableLessThanOrdersTotalWeight120Kg: '120kg以上のご予約から選択できます',
        zeroDeliveryFeeMessage: 'このロットの配送料は0円で処理してください。',
        mustBeZeroDeliveryFee: 'このロットの配送料は0円のみ許容されます',
        hasTargetWarehouseItemMessage: '注意: 配送料0円対象ロットが含まれています',
    },
    options: {
        isExists: {
            '1': 'あり',
            '0': 'なし',
        },
        isQGrader: {
            '1': 'Qグレーダー資格を保有している',
            '0': 'Qグレーダー資格を保有していない',
        },
    },
    stripePayment: {
        failure: 'お支払いが失敗しました。もう一度初めからやり直してください。',
        afterStatusSucceeded: 'お支払いは既に完了しております。支払い済みになるまでに少し時間がかかる場合があります。ご了承ください。',
    },
    tradeCountryUsages: {
        filter: 'Filter',
        espresso: 'Espresso',
        omniroast: 'Omniroast',
        blend_component: 'Blend component',
    },
    tradeCountryProcessings: {
        washed: 'Washed',
        honey: 'Honey',
        natural: 'Natural',
        washed_anaerobic: 'Washed Anaerobic',
        natural_anaerobic: 'Natural Anaerobic',
        experimental: 'Experimental',
    },
    tradeCountryPriceRanges: {
        '5_to_10_dollars': '$5~10',
        '10_to_15_dollars': '$10~15',
        '15_to_20_dollars': '$15~20',
        '20_to_30_dollars': '$20~30',
        '30_dollars_or_more': '$30~',
    },
    admin: {
        exportCsv: {
            title: 'CSVダウンロード',
            labels: {
                officeLabel: '拠点',
                fromDateLabel: '開始日',
                toDateLabel: '終了日',
                downloadButton: 'ダウンロード',
            },
            errors: {
                invalidDateFormat: '正しい日付のフォーマットで入力してください',
                toDateBeforeFromDate: '開始日より前の日付を設定できません',
            },
            taxReturns: {
                title: '税申告CSV',
            },
            accountingData: {
                title: '会計データCSV',
            },
            deliveryFee: {
                title: '配送料CSV',
            },
            warehouseFee: {
                title: '倉庫利用料CSV',
            },
            offerList: {
                title: 'オファーリストCSV',
            },
            pendingWarehouseFee: {
                title: '未請求倉庫利用料CSV',
            },
        },
    },
};
